import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faSearch } from '@fortawesome/free-solid-svg-icons';
import {
  Button, Icon, Col, Form, Input, DatePicker,
} from 'antd';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import Row from '../../components/Row';
import Card from '../../components/Card';
import Spacer from '../../components/Spacer';
import Select from '../../components/Select';
import ServerSideTable from '../../components/ServerSideTable';
import { fetchOptions, fetchOptionsLike } from '../ducks';
import { itemfetch } from './ducks';

export class ItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      options: {
        client: [],
        destination: [],
      },
      itemList: {
        rows: [],
        pages: 0,
        total: 0,
      },
      params: {
        page: 0,
        pageSize: 0,
        filter: [],
        sorted: [],
      },

      isFetching: false,
      handoverDate: '',
      isActiveDate: true,
    };

    this.onFetchData = this.onFetchData.bind(this);
  }

  componentDidMount() {
    const options = ['client', 'destination'];
    const { doFetchOptions } = this.props;

    Object.keys(options).forEach((key) => {
      doFetchOptions(options[key]).then((action) => {
        this.setState(prevState => ({
          options: {
            ...prevState.options,
            [options[key]]: action.payload.data.slice(0, 50),
          },
        }));
      });
    });
  }

  onFetchData(state, instance) {
    const { doItemfetch } = this.props;

    const params = {
      page: state.page,
      pageSize: state.pageSize,
      filter: {},
      sorted: [
        {
          id: 'client',
          desc: false,
        },
      ],
    };

    this.setState({
      isLoading: true,
    });

    doItemfetch(params).then((action) => {
      this.setState({
        itemList: {
          rows: action.payload.data.rows,
          pages: action.payload.data.pages,
          total: action.payload.data.total,
        },
        isLoading: false,
        params,
      });
    });
  }

  dateReferenceChange(e) {
    if (e === undefined) {
      this.setState({
        isActiveDate: true,
      });
    } else {
      this.setState({
        dateName: e,
        isActiveDate: false,
      });
    }
  }

  searchOption(type, e) {
    const { doFetchOptionsLike } = this.props;

    this.setState({
      isFetching: true,
    });

    doFetchOptionsLike(type, e).then((action) => {
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          [type]: action.payload.data.slice(0, 50),
        },
        isFetching: false,
      }));
    });
  }

  formSubmit() {
    const { params: paramsState, handoverDate, dateName } = this.state;
    const { form, doItemfetch } = this.props;
    const { validateFields } = form;
    // const filterByBranch = { client: 871 };

    validateFields((err, values) => {
      const params = {
        page: paramsState.page,
        pageSize: paramsState.pageSize,
        filter: { ...values, ...{ [dateName]: handoverDate } },
        sorted: paramsState.sorted,
      };

      if (!err) {
        this.setState({
          isLoading: true,
        });
        doItemfetch(params).then((action) => {
          // console.log(action);
          this.setState({
            itemList: {
              rows: action.payload.data.rows,
              pages: action.payload.data.pages,
              total: action.payload.data.total,
            },
            isLoading: false,
            params,
          });
        });
      }
    });
  }

  dateHandler(dateStrings) {
    const newDateOne = dateStrings[0];
    const newDateTwo = dateStrings[1];
    const formatDateOne = format(newDateOne, 'YYYY-MM-DD HH:mm:ss');
    const formatDateTwo = format(newDateTwo, 'YYYY-MM-DD HH:mm:ss');
    const dateForm = `${formatDateOne}|${formatDateTwo}`;

    this.setState({
      handoverDate: formatDateOne !== 'Invalid Date' ? dateForm : '',
    });
  }

  render() {
    const {
      isLoading, options, itemList, isFetching, isActiveDate,
    } = this.state;

    const breadCrumbs = [
      {
        breadcrumbName: 'Items',
      },
      {
        breadcrumbName: 'Item List',
      },
    ];

    const statusOption = [
      {
        value: 'picked',
        label: 'Picked',
      },
      {
        value: 'accepted_to_warehouse',
        label: 'Accepted To Warehouse',
      },
      {
        value: 'forwarded_to_branch',
        label: 'Forwarded To Branch',
      },
      {
        value: 'failed_delivery',
        label: 'Failed Delivery',
      },
      {
        value: 'delivery_successful',
        label: 'Delivery Successful',
      },
      {
        value: 'returned',
        label: 'Returned',
      },
      {
        value: 'claims',
        label: 'Claims',
      },
      {
        value: 'void',
        label: 'Item',
      },
    ];

    const itemListColumns = [
      {
        Header: 'Tracking Number',
        sortable: false,
        filterable: false,
        accessor: 'tracking_number',
      },
      {
        Header: 'Item ID',
        sortable: false,
        filterable: false,
        accessor: 'item_id',
      },
      {
        Header: 'Reference',
        sortable: false,
        filterable: false,
        accessor: 'reference',
      },
      {
        Header: 'Description',
        sortable: false,
        filterable: false,
        accessor: 'description',
      },
      {
        Header: 'Status',
        sortable: false,
        filterable: false,
        accessor: 'status',
      },
      {
        Header: 'Client Name',
        sortable: false,
        filterable: false,
        accessor: 'client_name',
      },
      {
        Header: 'Options',
        sortable: false,
        filterable: false,
        Cell: row => (
          <center>
            <NavLink to={`/items/${row.original.reference}/${row.original.item_id}`}>
              <Button type="link">
                <Icon viewBox="0 0 1024 1024">
                  <FontAwesomeIcon icon={faEye} fixedWidth />
                </Icon>
                view
              </Button>
            </NavLink>
          </center>
        ),
      },
    ];

    const { form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div className="ItemList">
        <PageHeader title="Item List" routes={breadCrumbs} />
        <Container>
          <Card>
            <Form>
              <Row>
                <Col xs={24} sm={8} lg={8}>
                  <Form.Item label="Date Reference">
                    <Select
                      style={{ width: '100%' }}
                      allowClear
                      // loading={isFetching}
                      options={[
                        { value: 'created_at', label: 'Created at' },
                        { value: 'updated_at', label: 'Updated at' },
                      ]}
                      onChange={e => this.dateReferenceChange(e)}
                      filterOption={false}
                      placeholder="Enter Date Reference"
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={16} lg={16}>
                  <Form.Item label="Date Range">
                    <DatePicker.RangePicker
                      disabled={isActiveDate}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [
                          moment('00:00', 'HH:mm'),
                          moment('00:00', 'HH:mm'),
                        ],
                      }}
                      style={{ width: '100%' }}
                      onChange={e => this.dateHandler(e)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={12} lg={12}>
                  <Form.Item label="Status">
                    {getFieldDecorator('status', {
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    })(
                      <Select
                        style={{ width: '100%' }}
                        allowClear
                        // loading={isFetching}
                        options={statusOption}
                        // onChange={e => this.labelChange(e)}
                        loading={isFetching}
                        onSearch={e => this.searchOption('destination', e)}
                        filterOption={false}
                        placeholder="Enter Package Status"
                        showSearch
                      />,
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={12}>
                  <Form.Item label="Location">
                    {getFieldDecorator('current_location', {
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    })(
                      <Select
                        style={{ width: '100%' }}
                        allowClear
                        // loading={isFetching}
                        options={options.destination}
                        // onChange={e => this.labelChange(e)}
                        loading={isFetching}
                        onSearch={e => this.searchOption('destination', e)}
                        filterOption={false}
                        placeholder="Enter Package Status"
                        showSearch
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={12} lg={12}>
                  <Form.Item label="Tracking Number">
                    {getFieldDecorator('tracking_number', {
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    })(
                      <Input.TextArea
                        placeholder="Enter Tracking Number..."
                        autoComplete="off"
                      />,
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={12}>
                  <Form.Item label="Reference">
                    {getFieldDecorator('reference', {
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    })(
                      <Input.TextArea
                        placeholder="Enter Reference..."
                        autoComplete="off"
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Spacer />
              <Button type="primary" onClick={() => this.formSubmit()} block>
                <Icon viewBox="0 0 1024 1024">
                  <FontAwesomeIcon icon={faSearch} fixedWidth />
                </Icon>
                Filter
              </Button>
            </Form>
          </Card>
          <Spacer />
          <Card extra={`Total: ${itemList.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}>
            <ServerSideTable
              data={itemList.rows}
              pages={itemList.pages}
              columns={itemListColumns}
              loadingText="Fetching item list. . ."
              loading={isLoading}
              onFetchData={this.onFetchData}
            />
          </Card>
        </Container>
      </div>
    );
  }
}

ItemList.propTypes = {
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doFetchOptionsLike: PropTypes.func.isRequired,
  doFetchOptions: PropTypes.func.isRequired,
  doItemfetch: PropTypes.func.isRequired,
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const mapDispatchToProps = {
  doFetchOptionsLike: fetchOptionsLike,
  doFetchOptions: fetchOptions,
  doItemfetch: itemfetch,
};

const mapStateToProps = state => ({
  user: state.auth.user,
});

const WrappedItemList = Form.create({ name: 'create' })(ItemList);
export default connect(mapStateToProps, mapDispatchToProps)(WrappedItemList);
